import React from 'react';
import { Sparkles } from 'lucide-react';
import PrimaryActionButton from './PrimaryActionButton';

type PublishActionButtonProps = React.ComponentProps<typeof PrimaryActionButton>;

const PublishActionButton: React.FC<PublishActionButtonProps> = ({ children = 'Publish Live', ...props }) => (
  <PrimaryActionButton {...props}>
    <Sparkles className="h-4 w-4" />
    {children}
  </PrimaryActionButton>
);

export default PublishActionButton;

